import React from "react";

// 一覧参照用
export type AdAsset = {
    adAccountId: number,
    adAssetName: string,
    adAssetId: number,
    creativeIds: Array<number>,
    formatId: number,
    mailData: MailData,
    createdDatetime: string,
    updatedDatetime: string,
}

export type AdAssetsEditProps = {
    accountId: string;
    campaignId: string;
    editType: number;
}

export type MailData = {
    commonItems: CommonItems,
    singleItems: SingleItems,
    customItems: CustomItems,
}

export type SingleItems = {
    imageItem: ImageItem,
    textLinkItem1: TextLinkItem,
    textLinkItem2: TextLinkItem,
    textItem: TextItem,
}

export type CustomItems = {
    lineColor: string,
    sectionItems: SectionItem[],
}

export type CommonItems = {
    assetName: string,
    textPosType: string,
    subject: string,
    formatId: number,
    buttonLinkItem: ButtonLinkItem,
    notation: string,
    lastUpdatedVer: string,
}

export type SectionItem = {
    isOpen: boolean,
    imageUrl: string,
    imageSize: number,
    imageName: string,
    enableLine: boolean,
    shortText: string,
    largeText: string,
    textLink: string,
    transitionUrl: string,
}

export type TextItem = {
    text: string,
}

export type ImageItem = {
    imageUrl: string,
    imageSize: number,
    imageName: string,
    transitionUrl: string,
}

export type TextLinkItem = {
    text: string,
    transitionUrl: string,
}

export type ButtonLinkItem = {
    imageUrl: string,
    labelType: string,
    colorType: string,
    transitionUrl: string,
}

//const
export const AdAssetProcessType = {
    create: "create",
    edit: "edit",
    copy: "copy",
    preview: "preview",
}

// previewItems
export const AdAssetPreviewDipsTime = "20XX/04/01 12:00:00"
export const AdAssetPreviewHeaderIconUrl = "/icon/ms/ms_prev_header.png"
export const AdAssetPreviewClockIconUrl = "/icon/ms/ms_prev_time.png"
export const AdAssetPreviewSubjectIconUrl = "/icon/ms/ms_prev_title.png"
export const AdAssetPreviewFooterFreeIconUrl = "/icon/ms/ms_prev_footer_free.png"
export const AdAssetPreviewButtonLinkImgPath = "/img/ms/linkButtonImg"

// previewAreaType
export const AdAssetPreviewAreaType = {
    small: "small",
    large: "large",
    largeLink: "largeWithLink",
}

// label
export const AdAssetPreviewCommonAreaNames = {
    linkButton: "画像リンクボタン",
};

export const AdAssetPreviewSingleAreaNames = {
    image1: "画像1",
    textLink1: "テキストリンク1",
    textLong1: "テキスト(長文)1",
    textLink2: "テキストリンク2",
};

export const AdAssetPreviewCustomAreaNames = {
    image1: "画像1",
    line1: "ライン1",
    textShort1: "テキスト(短文)1",
    line2: "ライン2",
    textLong1: "テキスト(長文)1",
    textLink1: "テキストリンク1",
};

export const ButtonLabelDelete = "削除"

export const ImageDropZoneMessage = "ここにファイルをドラッグ＆ドロップ\nもしくは、クリックして選択"

export const AdAssetCommonItemParts = {
    assetName: {label: "広告アセット名", id: "assetName"},
    subject: {label: "件名", id: "subject"},
    formatId: {label: "フォーマット種別", id: "formatId"},
    textPos: {label: "テキスト表示位置", id: "textPosType"},
    notation: {label: "主体者表記", id: "notation"},
    linkButtonLabel: {label: "表示ラベル", id: "linkButtonLabel"},
    linkButtonColor: {label: "カラー", id: "linkButtonColor"},
    linkButtonTransitionUrl: {label: "遷移先URL", id: "linkButtonTransitionUrl"},
}

export const AdAssetDisableEditMessage = "広告に紐づいているため広告アセット名のみ編集可能となります。"

export const AdAssetLabelFormatId = {
    single: "シングル画像",
    custom: "カスタム画像",
}

export const AdAssetBoxLabel = {
    image: "画像",
    textLink: "テキストリンク",
    textLong: "テキスト本文",
    linkButton: "リンクボタン",
    section: "セクション",

}

export const AdAssetSingleItemParts = {
    image: {label: "画像 ※", id: "singleImage"},
    transitionUrlForImage: {label: "遷移先URL", id: "singleTransitionUrlForImage"},
    textLink: {label: "テキスト", id: "singleTextLink"},
    transitionUrlForTextLink: {label: "遷移先URL", id: "singleTransitionUrlForTextLink"},
    text: {label: "テキスト(本文)", id: "singleTextLong"},
}

export const AdAssetCustomItemParts = {
    imageForSection: {label: "画像", id: "imageForSection"},
    lineColor: {label: "ラインの色", id: "lineColor"},
    enableLineFroSection: {label: "ライン設定有無", id: "enableLineFroSection"},
    textShortForSection: {label: "テキスト(短文)1", id: "textShortForSection"},
    textLongForSection: {label: "テキスト(長文)1", id: "textLongForSection"},
    textLinkForSection: {label: "テキストリンク1", id: "textLinkForSection"},
    transitionUrlForSection: {label: "遷移先URL", id: "transitionUrlForSection"},
}

export const AdAssePartsBlockNames = {
    image: "画像",
    textLink: "テキストリンク",
}

export const AdAssetCopyDefaultSubject = ""

export const AdAssetTextPosType = {
    left: "left",
    center: "center",
}

export const AdAssetFormatId = {
    single: 4,
    custom: 5,
}

export const AdAssetImageType = {
    JPG: "jpg",
    JPEG: "jpeg",
    GIF: "gif",
}

export const AdAssetImageLimitSize = {
    MAXBYTE: 150 * 1024,
    TOTALMAXTBYTE: 675 * 1024,

}

export const AdAssetColor = {
    green: {
        value: "#4CAF50",
        label: "green"
    },
};

export const AdAssetPreviewTextConfigText = {
    color: "black",
}

export const AdAssetPreviewTextConfigTextForLink = {
    color: "blue",
    textDecoration: "underline",
    textDecorationColor: "blue",
}

export const AdAssetPreviewBboxLargeForLink = {
    padding: "13px",
    color: "blue",
    textDecoration: "underline",
    textDecorationColor: "blue",
}

export const AdAssetPreviewBboxLarge = {
    padding: "13px",
}

export const AdAssetPreviewBboxSmall = {
    padding: "2px",
}

export const AdAssetPreviewMemoBegin = "■配信元：（株）NTTドコモ\n" +
    "東京都千代田区永田町2-11-1 山王パークタワー\n" +
    "※このメッセージには返信できません。\n" +
    "※受信にはパケット通信料が発生します。また海外で受信される場合には、国内のパケット定額サービスの適用外となり、別途通信料がかかります。\n" +
    "※各サイトへ接続した場合、パケット通信料がかかります。\n" +
    "※お客様のご利用環境によりうまく表示されない場合があります。\n" +
    "※このメッセージはお客様の同意に基づいてお届けしております。"

export const AdAssetContact = {
    url: "https://www.docomo.ne.jp/support/inquiry/",
    label: "こちら",
    preLabel: "■お問い合わせは",
}

export const AdAssetPreviewSetting = {
    url: "https://cfgf.smt.docomo.ne.jp/cgi/msgs/consentset",
    label: "こちら",
    preLabel: "■メッセージSの受信設定・停止は",
}

export const initButtonLinkItem: ButtonLinkItem = {
    imageUrl: "",
    labelType: "",
    colorType: AdAssetColor.green.label,
    transitionUrl: "",
}

export type initPictureFile = {
    pictureFileName: "",
    pictureFileUrl: "",
}

export const initTextLinkItem: TextLinkItem = {
    text: "",
    transitionUrl: "",
}

export const initImageItem: ImageItem = {
    imageUrl: "",
    imageSize: 0,
    imageName: "",
    transitionUrl: "",
}

export const initTextItem: TextItem = {
    text: "",
}

export const initSectionItem: SectionItem = {
    isOpen: false,
    imageUrl: "",
    imageSize: 0,
    imageName: "",
    enableLine: false,
    shortText: "",
    largeText: "",
    textLink: "",
    transitionUrl: "",
}

const initCommonItems: CommonItems = {
    assetName: "",
    textPosType: AdAssetTextPosType.left,
    subject: "",
    formatId: AdAssetFormatId.single,
    notation: "",
    buttonLinkItem: {...initButtonLinkItem},
    lastUpdatedVer: "",
}

export const initCustomItems: CustomItems = {
    lineColor: AdAssetColor.green.value,
    sectionItems: [{
        ...initSectionItem,
        isOpen: true,
    },
        initSectionItem,
        initSectionItem,
        initSectionItem,
    ],
}

export const initSingleItems: SingleItems = {
    imageItem: {...initImageItem},
    textLinkItem1: {...initTextLinkItem},
    textItem: {...initTextItem},
    textLinkItem2: {...initTextLinkItem,},
}

export const initMailData: MailData = {
    commonItems: {...initCommonItems},
    singleItems: {...initSingleItems},
    customItems: {...initCustomItems},
}

export const InitAdAsset: AdAsset = {
    adAccountId: 0,
    adAssetName: "",
    adAssetId: 0,
    creativeIds: [],
    formatId: 0,
    mailData: initMailData,
    createdDatetime: "",
    updatedDatetime: "",
}

export const AdAssetTitleList = {

    image: "画像",
    textLink1: "テキストリンク1",
    textLong: "テキスト本文",
    textLink2: "テキストリンク2",
    linkButton: "リンクボタン",
    section: "セクション",

}

export const AdAssetLabelList = {

    assetName: "広告アセット名",
    subject: "件名",
    imageFilename: "画像ファイル名",
    transitionUrl: "遷移先URL",
    text: "テキスト",
    textLong: "テキスト(本文)",
    buttonLabel: "表示ラベル",
    notation: "主体者表記",
    textSecShort: "テキスト(短文)",
    textSecLong: "テキスト(長文)",
    textSecLink: "テキストリンク",
}

/** 免責文言 */
export const ImmunityMessage: string[] = [
    "※CSVアップロード時：機種依存文字はCSVファイル保存時に「?」へ置換される場合がございます。この場合、新規登録・更新内容も「?」となりますのでご注意ください",
]

